import React from 'react';
import { siteContent } from '../data/mock';

const SolutionSection = () => {
  const { solution } = siteContent;

  return (
    <section className="solution-section section-padding" data-testid="solution-section" data-reveal="fade">
      <div className="container">
        <div className="solution-header">
          <h2 className="solution-main-title" data-testid="solution-title">{solution.title}</h2>
          <p className="solution-subtitle">{solution.subtitle}</p>
        </div>

        <p className="solution-introduction">{solution.introduction}</p>
        <blockquote className="solution-key-phrase" data-testid="solution-key-phrase">
          {solution.keyPhrase}
        </blockquote>

        <p className="solution-existential-note">{solution.existentialNote}</p>

        <div className="solution-details-grid">
          <div className="content-card solution-detail-card" data-testid="what-it-is">
            <h3 className="detail-card-title">{solution.whatItIs.title}</h3>
            <ul className="detail-list">
              {solution.whatItIs.items.map((item, index) => (
                <li key={index} className="detail-list-item">{item}</li>
              ))}
            </ul>
          </div>

          <div className="content-card solution-detail-card not-card" data-testid="what-it-is-not">
            <h3 className="detail-card-title">{solution.whatItIsNot.title}</h3>
            <ul className="detail-list">
              {solution.whatItIsNot.items.map((item, index) => (
                <li key={index} className="detail-list-item">{item}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="content-card how-it-works-card" data-testid="how-it-works">
          <h3 className="how-it-works-title">{solution.howItWorks.title}</h3>
          <p className="how-it-works-schedule">{solution.howItWorks.schedule}</p>
          <p className="how-it-works-format">{solution.howItWorks.format}</p>
          <ul className="how-it-works-structure">
            {solution.howItWorks.structure.map((item, index) => (
              <li key={index} className="structure-item">{item}</li>
            ))}
          </ul>
          <p className="how-it-works-practical">{solution.howItWorks.practical}</p>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
